import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=f3c24e44&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=f3c24e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c24e44",
  null
  
)

export default component.exports